import { render, staticRenderFns } from "./Register.vue?vue&type=template&id=08cf4e30&"
import script from "./Register.ts?vue&type=script&lang=ts&"
export * from "./Register.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Register.vue"
export default component.exports